import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useInput, FieldTitle } from 'ra-core';
import {
    DatePicker,
    TimePicker,
    DateTimePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const Picker = ({ PickerComponent, ...fieldProps }) => {

    const {
        options,
        label,
        source,
        resource,
        className,
        isRequired,
        providerOptions,
        variant,
        inputVariant,
        formClassName
    } = fieldProps;

    const { input, meta } = useInput({ source });

    const { touched, error } = meta;

    const handleChange = useCallback(value => {
        Date.parse(value) ? input.onChange(value.toISOString()) : input.onChange(null);
    }, [input]);

    const normalizeTime = (value) => {
        if (value && value.match(/^[0-9]{2}:[0-9]{2}:[0-9]{2}$/)) {
            return '1970-01-01T' + value
        }
        return value
    }

    return (
        <div className="picker">
            <MuiPickersUtilsProvider {...providerOptions}>
                <PickerComponent
                    {...options}
                    variant={variant}
                    formClassName={formClassName}
                    label={<FieldTitle
                        label={label}
                        source={source}
                        resource={resource}
                        isRequired={isRequired}
                    />}
                    margin="normal"
                    inputVariant={inputVariant}
                    error={!!(touched && error)}
                    helperText={touched && error}
                    className={className}
                    value={input.value ? new Date(normalizeTime(input.value)) : null}
                    onChange={date => handleChange(date)}
                    onBlur={() => input.onBlur(input.value ? new Date(normalizeTime(input.value)).toISOString() : null)}
                />
            </MuiPickersUtilsProvider>
        </div>
    )
}

Picker.propTypes = {
    variant: PropTypes.oneOf('dialog', 'inline', 'static'),
    input: PropTypes.object,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    meta: PropTypes.object,
    options: PropTypes.object,
    resource: PropTypes.string,
    source: PropTypes.string,
    labelTime: PropTypes.string,
    className: PropTypes.string,
    formClassName: PropTypes.string,
    inputVariant: PropTypes.oneOf('standard', 'outlined', 'filled'),
    providerOptions: PropTypes.shape({
        utils: PropTypes.func,
        locale: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    }),
};

Picker.defaultProps = {
    input: {},
    isRequired: false,
    meta: { touched: false, error: false },
    options: {},
    resource: '',
    source: '',
    labelTime: '',
    className: '',
    formClassName: '',
    variant: 'dialog',
    inputVariant: 'filled',
    providerOptions: {
        utils: DateFnsUtils,
        locale: undefined,
    },
};

export const DateInput = props => <Picker PickerComponent={DatePicker} {...props} />
export const TimeInput = props => <Picker PickerComponent={TimePicker} {...props} />
export const DateTimeInput = props => <Picker PickerComponent={DateTimePicker} {...props} />
